// components/layout/MetaBar.jsx
// 体系元信息条: 体系名 + CAS + 5 个核心指标

import { useSolPred } from '../../hooks/useSolPredStore';

export default function MetaBar() {
  const { selectedSystem } = useSolPred();

  return (
    <div className="meta-bar">
      <div className="meta-title-block">
        <div className="meta-title">{selectedSystem.components.join(' – ')} 三元体系</div>
        <div className="meta-subtitle">
          {selectedSystem.id} · CAS {selectedSystem.cas.join(' / ')} · {selectedSystem.family}
        </div>
      </div>
      <div className="meta-stats">
        <div className="meta-stat">
          <div className="meta-stat-label">数据点</div>
          <div className="meta-stat-value">{selectedSystem.dataPoints}</div>
          <div className="meta-stat-sub">实验测定</div>
        </div>
        <div className="meta-stat">
          <div className="meta-stat-label">温度域</div>
          <div className="meta-stat-value">{selectedSystem.tempRange[0]}–{selectedSystem.tempRange[1]}</div>
          <div className="meta-stat-sub">°C 范围</div>
        </div>
        {selectedSystem.hasModel ? (
          <>
            <div className="meta-stat">
              <div className="meta-stat-label">R²</div>
              <div className="meta-stat-value success">{selectedSystem.r2}</div>
              <div className="meta-stat-sub">验证集</div>
            </div>
            <div className="meta-stat">
              <div className="meta-stat-label">MAE</div>
              <div className="meta-stat-value">{selectedSystem.mae}</div>
              <div className="meta-stat-sub">平均误差</div>
            </div>
            <div className="meta-stat">
              <div className="meta-stat-label">推理</div>
              <div className="meta-stat-value accent">&lt;100</div>
              <div className="meta-stat-sub">ms · CPU</div>
            </div>
          </>
        ) : (
          <div className="meta-stat">
            <div className="meta-stat-label">模型</div>
            <div className="meta-stat-value" style={{ color: 'var(--warning)' }}>待训练</div>
            <div className="meta-stat-sub">数据已就位</div>
          </div>
        )}
      </div>
    </div>
  );
}
